<div class="row">
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <EIPMultiSelectAutoComplete [dataSource]="businessGroupList" setId="group_Name" TextField="group_Name" ValueField="group_Id" WaterMarkText="Business Group" ShowTextValueField='N' isEmitOnSelect="Y" (valueChange)="onChange_Member($event,1)">
        </EIPMultiSelectAutoComplete>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <EIPMultiSelectAutoComplete [dataSource]="moduleList" setId="ddMrlBusGrpId2" TextField="cedDescription" ValueField="cedId" WaterMarkText="Module" ShowTextValueField='N' isEmitOnSelect="Y" (valueChange)="changeModule($event)">
        </EIPMultiSelectAutoComplete>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <EIPAutoComplete ShowTextValueField='N' WaterMarkText="Element" TextField="dE_Description" ValueField="dE_Id" [clearValue]='clearElementDD' [dataSource]='elementList' setId="ddMrlBusGrpId3" (valueChange)='changeElement($event)' [IsCascading]='true'>
        </EIPAutoComplete>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <EIPAutoComplete ShowTextValueField='N' WaterMarkText="Dependent On Element" TextField="dependentElementDescription" ValueField="dependentElementId" [SingleValueBind]="false" [dataSource]='dependentElementList' setId="ddMrlBusGrpId4" (valueChange)='changeDependentElement($event)' [IsCascading]='true'>
        </EIPAutoComplete>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <EIPAutoComplete ShowTextValueField='N' WaterMarkText="Dependent On Element Detail" TextField="dedDescription" ValueField="dedId" [dataSource]='dependentElementDetailsList' setId="ddMrlBusGrpId5" (valueChange)='changeDependentElementDetail($event)' [IsCascading]='true'>
        </EIPAutoComplete>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
        <div style="padding-top: 10px;">
            <a (click)="openElementDetailDialog()" class="hyperlink-custom">
                Create new Element Detail
            </a>
        </div>
    </div>
</div>
<div class="row" *ngIf='elementId' style="margin-top: 3%;">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <EIPGeneralCart [CartParameters]="cartRequest" (OnCartSubmit)='getSelectedCartItems($event)' (OnClick)='setCartParams()'></EIPGeneralCart>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="cartSelectedList.length > 0">
        <table style="border: 1px solid #dee2e6; width:100%; display: block;height: 450px;overflow-y: scroll;">
            <thead style="background: #1063a1; color: white; border-bottom: 2px solid #dee2e6;position: sticky;top: 0px;">
                <tr style="border-bottom: 1px solid #dee2e6;">
                    <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;width: 10%;position: sticky;top: 0px;">Sl. No.</th>
                    <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;width: 70%;position: sticky;top: 0px;">Element Detail</th>
                    <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;width: 20%;position: sticky;top: 0px;">Sort By</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of  cartSelectedList;let i=index" style="background-color: #f2f0f0; border-bottom: 1px solid #dee2e6; line-height:14px;">
                    <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6; height: 14px;">{{i+1}}</td>
                    <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; height: 14px;">{{data.text}}</td>
                    <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; height: 14px;">                       
                        <input type="number" required  [ngModel]="(!!data.orderBy && data?.orderBy)?data.orderBy: i+1" 
                        (ngModelChange)="(!!data.orderBy && data?.orderBy) ? (data.orderBy = $event) : i+1">
                    </td>
                </tr>
            </tbody>
        </table>
     
        <button style="margin-top: 3%;float: right;" class="btn btn-primary" id="BtnUpdate" (click)="updateElementDetailsSortOrder()"><i class="fa fa-re-edit" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Update</button>
    </div>
</div>